import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgTickSmallInvoiced({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#CCC" cx={8} cy={8} r={8} />
        <path
          d="M8.45 3.79c.22 0 .39.17.39.38l-.02 3.84 2.59 1.9c.17.12.21.36.08.54l-.53.73a.4.4 0 01-.54.08L7.32 9a.4.4 0 01-.16-.32v-4.5c0-.22.17-.4.39-.4h.9z"
          fill="#FFF"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

SvgTickSmallInvoiced.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgTickSmallInvoiced.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgTickSmallInvoiced svgRef={ref} {...props} />
));
export default ForwardRef;
